<template>
  <div class="">
    <soha-modal
      :id="modalId"
      :title="$t(`${I18nPrefix}TITLE`)"
      @hide="clearModalData"
      @show="getMessagePatterns"
    >
      <template #activator>
        <slot />
      </template>
      <template #body>
        <div class="row justify-content-center">
          <div class="col col-md-10">
            <div class="w-100 soha-send-group-message-label">
              {{ $t(`${I18nPrefix}SELECTED_PEOPLE_TEXT`) }}
              <span class="ml-2">{{ toPersianDigits(resumeIds.length) }}</span>
              {{ $t(`${I18nPrefix}PERSON`) }}
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-6">
          <div class="col col-md-10">
            <soha-select
              v-model="patternToSend.value"
              class="w-100"
              name="messageText"
              :placeholder="$t(`${I18nPrefix}SELECT_PLACEHOLDER`)"
              :options="patternOptions"
              :error="patternToSend.error"
              @on-change="setMessageText"
            />
          </div>
        </div>
        <div class="row justify-content-center mt-6">
          <div class="col col-md-10">
            <soha-text-area
              v-model="text"
              class="w-100"
              name="messageDescription"
              :read-only="true"
              :placeholder="$t(`${I18nPrefix}DESCRIPTION_PLACEHOLDER`)"
            />
          </div>
        </div>

        <div class="row justify-content-center mt-15">
          <div class="col col-md-10">
            <soha-button
              name="submitMessage"
              :loading="submitLoading"
              class="w-100"
              :text="$t(`${I18nPrefix}SUBMIT_BTN_TEXT`)"
              @btn-click="sendMessage"
            />
          </div>
        </div>
      </template>
    </soha-modal>
  </div>
</template>

<script>
import "@/assets/css/components/base/send-group-message.css";
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
export default {
  name: "SendGroupMessage",

  mixins: [ValidationMixin, UIMixin],

  props: {
    resumeIds: {
      type: Array,
      default: null,
    },
    modalId: {
      type: String,
      default: "send-message-modal"
    }
  },

  emits: ['hide'],

  data() {
    return {
      I18nPrefix: "COMPONENTS.BASE.SEND_GROUP_MESSAGE.",
      patternToSend: {
        value: null,
        error: null,
      },
      text: null,
      submitLoading: false,
      messagePatternList: [],
      patternOptions: [],
    };
  },

  methods: {
    setMessageText(message) {
      this.text = this.messagePatternList.find((item) => {
        return item.id == message.id;
      }).text;
    },

    sendMessage() {
      this.patternToSend.error = this.validateField(
        this.patternToSend.value,
        this.$t(`${this.I18nPrefix}SELECT_PLACEHOLDER`)
      );
      if (this.patternToSend.error) return;

      this.submitLoading = true;
      ApiService.post(
        "api/v2/message-patterns/send-group/" + this.patternToSend.value,
        {
          resumeIds: this.resumeIds,
        }
      ).then(({ data }) => {
        if (+data.code === 228) {
          this.$modal.hide("send-message-modal");
          this.successToast(data.message);
        } else {
          this.errorToast(data.message);
        }
        this.submitLoading = false;
      });
    },

    getMessagePatterns() {
      ApiService.get("api/v2/message-patterns").then(({ data }) => {
        if (data) {
          this.messagePatternList = data;
          this.patternOptions = [];
          this.messagePatternList.map((item) => {
            this.patternOptions.push({
              text: item.name,
              id: item.id,
            });
          });
        } else {
          this.errorToast(data.message);
        }
      });
    },

    showModal() {
      this.$modal.show("send-message-modal");
    },

    clearModalData() {
      this.$emit("hide");
      this.patternToSend = {
        value: null,
        error: null,
      };
      this.text = null;
      this.submitLoading = false;
    },
  },
};
</script>
